import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  CssBaseline,
  Paper,
  useMediaQuery,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import ArrowBack from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";
import { customerLogout } from "store/slice/customer/customerSlice";

const Footer = ({ value, setValue }) => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:600px)");

  const ImpersonateBy = localStorage.getItem("ImpersonateBy");
  const superAdmin = localStorage.getItem("SuperAdmin");

  const handleLogout = () => {
    dispatch(customerLogout());
    window.location.href = "/parker-login";
  };

  const handleBack = () => {
    localStorage.setItem("Authorization", ImpersonateBy);
    localStorage.removeItem("ImpersonateBy");

    if (superAdmin) {
      localStorage.setItem("ImpersonateBy", superAdmin);
      localStorage.removeItem("SuperAdmin");
    }

    window.location.href = "/subscriptions";
  };

  return (
    <>
      <CssBaseline />

      {/* Footer spacer so content is not hidden */}
      <div style={{ height: 56 }} />

      <Paper
        elevation={6}
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          zIndex: 1300, // important
        }}
      >
        <BottomNavigation
          value={value}
          showLabels={!isMobile}
          onChange={(event, newValue) => setValue(newValue)}
        >
          {ImpersonateBy && (
            <BottomNavigationAction
              label={isMobile ? "" : "Back"}
              icon={<ArrowBack />}
              onClick={handleBack}
            />
          )}

          <BottomNavigationAction
            label={isMobile ? "" : "Subscriptions"}
            icon={<PendingActionsIcon />}
          />

          <BottomNavigationAction
            label={isMobile ? "" : "History"}
            icon={<HistoryIcon />}
          />

          <BottomNavigationAction
            label={isMobile ? "" : "Logout"}
            icon={<LogoutIcon />}
            onClick={handleLogout}
          />
        </BottomNavigation>
      </Paper>
    </>
  );
};

export default Footer;
